import React, { Component } from 'react'
import PageHeaderWrapper from '../../components/PageHeaderWrapper'
import { Card, Form, Button, notification } from 'antd'
import Request, { API_URL } from '../../request'
import moment from 'moment'


@Form.create()

class ViewAnnoucement extends Component {
  state = {
    id: '',
    total: 0,
    announcements: [],
    activeUser: ''
  }

  apiRequest = async () => {
    let params = {
      results: 1000,
      sortField: 'createdByUser.time',
      sortOrder: 'descend'
    };
    let response = await Request.getAnnouncements(params);
    this.setState({ total: response.total, announcements: response.data })
  }
  componentWillMount() {
  }

  async componentDidMount() {
    await this.apiRequest();
    let currentUser = JSON.parse(localStorage.getItem('user'));
    this.setState({ activeUser: currentUser._id.toString() })
  }

  reload() {
    window.location.reload()
  }

  handleAnnoucementAction = async (data) => {
    let response = await Request.updateAnnoucement({ _id: data._id });
    if (response.success) {
      notification.success({
        message: response.message
      })
      setTimeout(()=>{
        this.reload();
      },50)
    } else {
      notification.error({
        message: response.message
      })
    }
  }

  render() {

    const { announcements, total, activeUser } = this.state;
    return (
      <PageHeaderWrapper title={` Announcements: ${total} `}>
        <Card bordered={true}>
          <div className="leaderboard">
            <main className="leaderboard__profiles">
              {
                announcements && announcements.map((annoucement, index) => {
                  return (
                    <article key={index} className="leaderboard__profile">
                      {/* <span className="leaderboard__name">{suggestion.title}</span> */}
                      <small><b>BY: </b>{annoucement.createdByUser.name} / {moment(annoucement.createdByUser.time).format('lll')}</small>
                      <p className="faq-desc" dangerouslySetInnerHTML={{ __html: annoucement.annoucementText }}></p>
                      <p className="faq-desc">

                        {
                          (() => {
                            const userAcknowledgement = annoucement.acknowledgedBy.find(user => user.userId === activeUser);
                            return userAcknowledgement && userAcknowledgement.acknowledged
                              ? null
                              : <Button className='btn btn-raised-ticket ant-btn-primary' type='button'
                                onClick={() => this.handleAnnoucementAction(annoucement)}>
                                Accept
                              </Button>;
                          })()
                        }
                        {/* {
                          suggestion.suggestionStatus === 'Pending' ?
                          <Button className='btn btn-raised-ticket ant-btn-primary' type='button' onClick={(e) => {this.completeTicket(suggestion._id)}}>Accept</Button>
                          :null
                        }                         */}
                      </p>
                    </article>
                  )
                })
              }
            </main>
          </div>
        </Card>
      </PageHeaderWrapper>
    );
  }
}

export default ViewAnnoucement
